import { OnBoardingScreenOptions } from '@mindly/ui-components';

export const ONBOARDING_SCREEN_OPTIONS_WITHOUT_PROGRESS_BAR = [
  OnBoardingScreenOptions.START,
  OnBoardingScreenOptions.LOADER,
  OnBoardingScreenOptions.PAYWALL,
  OnBoardingScreenOptions.LIST_LOADER,
];
